import { useEffect } from 'react';

import { stringify as queryStringify, parse as queryParse } from 'querystring';

export const useQueryParamsAppender = (
  linkMatcher: string | RegExp,
  params: Record<string, any>,
  deps: any[],
) => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const regex = new RegExp(linkMatcher);

      // filter undefined and empty strings
      const filteredParams = Object.keys(params).reduce<Record<string, any>>(
        (acc, curr) => {
          if (typeof params[curr] !== 'undefined' && params[curr] !== '')
            acc[curr] = params[curr];
          return acc;
        },
        {},
      );

      // get <a> - anchor tags with [href] attribute
      const anchors = Array.from<HTMLAnchorElement>(
        document.querySelectorAll('a[href]'),
      ).filter((link) => {
        const href = link.getAttribute('href');
        if (href && href.match(regex)) return true;
      });

      // append query params (override original ones)
      anchors.forEach((anchor) => {
        const [path, query] = anchor.href.split('?');
        const originalParams = queryParse(query);
        if (query || Object.keys(filteredParams).length)
          anchor.href = `${path}?${queryStringify({
            ...originalParams,
            ...filteredParams,
          })}`;
      });
    }
  }, deps);
};
